import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from "react";
import ReactDOMServer from "react-dom/server";
import colorContrast from "color-contrast";
import { FaInfoCircle } from "react-icons/fa";
import { Tooltip } from "react-tooltip";
import "react-tooltip/dist/react-tooltip.css";
import CustomColorPicker from "../../util/colorPickerInput/customColorPicker";
import styled from "styled-components";
const StylesContainer = styled.div.withConfig({ displayName: "StylesContainer", componentId: "-uzad58" }) `
  padding: 0;
`;
const Columns2 = styled.div.withConfig({ displayName: "Columns2", componentId: "-12hqdor" }) `
  display: grid;
  grid-template-columns: repeat(2, 1fr);
`;
const Column = styled.div.withConfig({ displayName: "Column", componentId: "-8cs7z4" }) `
  position: relative;
  display: flex;
  flex-direction: column;
  flex: 1;
  padding-bottom: 2rem;

  & + & {
    border-left: solid 1px var(--border-color);
  }

  &:first-child {
    .lt-field-group {
      padding-inline-start: 2rem;
    }
  }

  &:last-child {
    .lt-field-group {
      padding-inline-end: 2rem;
    }
  }

  fieldset {
    padding-bottom: 1rem;
    border: 0;
  }
`;
const ColumnTitle = styled.div.withConfig({ displayName: "ColumnTitle", componentId: "-zxrdkx" }) `
  border-bottom: solid 1px var(--border-color);
  padding: 0.85rem 1.5rem;
  text-transform: uppercase;
  font-weight: 600;
`;
const SelectFont = styled.fieldset.withConfig({ displayName: "SelectFont", componentId: "-1nhi14y" }) `
  && {
    padding-block: 1rem;
  }
`;
const AllyChecker = styled.fieldset.withConfig({ displayName: "AllyChecker", componentId: "-n6o2s2" }) `
  position: relative;
  z-index: 10;

  && {
    padding-block: 0;
  }

  svg {
    margin-inline: 5px;
  }
`;
const InfoMessage = styled.div.withConfig({ displayName: "InfoMessage", componentId: "-d62oaa" }) `
  font-size: 9px;
  padding-inline: 28px;
  width: 100%;
`;
export const Style = (props) => {
    const [menuStyle, setMenuStyle] = useState(props.existingStyles.menuStyle);
    const [logoUrl, setLogoUrl] = useState(props.existingStyles.logoUrl);
    const [logoLinkUrl, setLogoLinkUrl] = useState(props.existingStyles.logoLinkUrl);
    const [colors, setColors] = React.useState({
        level1: {
            background: props.existingStyles.firstLevelBackgroundColor,
            text: props.existingStyles.firstLevelFontColor,
            textFormat: props.existingStyles.firstLevelTextFormat,
        },
        level2: {
            textFormat: props.existingStyles.secondLevelTextFormat,
        },
        level3: {
            textFormat: props.existingStyles.thirdLevelTextFormat,
        },
    });
    React.useEffect(() => {
        const newStyle = {
            menuLevelsStyles: colors,
            menuStyle: menuStyle,
            logoUrl: logoUrl,
            logoLinkUrl: logoLinkUrl,
        };
        props.updateStyles(newStyle);
        setLevel1Contrast(getContrast(colors.level1.text, colors.level1.background));
    }, [colors, menuStyle, logoUrl, logoLinkUrl]);
    const getContrast = (bgColor, textColor) => {
        const contrast = colorContrast(bgColor, textColor).toFixed(2);
        if (contrast < 4.5) {
            return { contrast, color: "#fbad3c" };
        }
        if (contrast >= 4.5 && contrast <= 7) {
            return { contrast, color: "#8bc34a" };
        }
        if (contrast > 7) {
            return { contrast, color: "#3eb124" };
        }
    };
    const [Level1Contrast, setLevel1Contrast] = React.useState(getContrast(colors.level1.text, colors.level1.background));
    return (_jsxs(StylesContainer, { children: [_jsxs(SelectFont, Object.assign({ className: "lt-style" }, { children: [_jsx("label", { children: "Logo Source" }), _jsx("input", { type: "text", value: logoUrl, onChange: (e) => setLogoUrl(e.target.value), placeholder: "Insert the URL to your logo", className: "lt-style" })] })), _jsxs("fieldset", Object.assign({ className: "lt-style" }, { children: [_jsx("label", { children: "Logo URL" }), _jsx("input", { type: "text", value: logoLinkUrl, onChange: (e) => setLogoLinkUrl(e.target.value), placeholder: "Insert the URL link to your logo", className: "lt-style" })] })), _jsxs("fieldset", Object.assign({ className: "lt-style" }, { children: [_jsx("label", { children: "Menu Style" }), _jsxs("select", Object.assign({ className: "lt-style", value: menuStyle, onChange: (e) => setMenuStyle(e.target.value) }, { children: [_jsx("option", Object.assign({ value: "classic" }, { children: "Classic" })), _jsx("option", Object.assign({ value: "compact" }, { children: "Compact" }))] }))] })), _jsxs(Columns2, { children: [_jsxs(Column, { children: [_jsx(ColumnTitle, Object.assign({ style: { paddingInlineStart: "var(--default-gutter)" } }, { children: "Title bar" })), _jsxs("fieldset", Object.assign({ className: "lt-style" }, { children: [_jsx("label", { children: "Background Color:" }), _jsx(CustomColorPicker, { level: "lvl1-bg", color: colors.level1.background, onChange: (color) => setColors(Object.assign(Object.assign({}, colors), { level1: Object.assign(Object.assign({}, colors.level1), { background: color }) })) })] })), _jsxs("fieldset", Object.assign({ className: "lt-style" }, { children: [_jsx("label", { children: "Text Color" }), _jsx(CustomColorPicker, { level: "lvl1-txt", color: colors.level1.text, onChange: (color) => setColors(Object.assign(Object.assign({}, colors), { level1: Object.assign(Object.assign({}, colors.level1), { text: color }) })) })] })), _jsxs(InfoMessage, { children: ["WCAG provides accessibility guidelines for web content. WCAG AA ensures inclusive experiences with higher compliance, while WCAG AAA offers the highest conformance level.(Contrast ratio standards: AA", " ", ">", " 4.5 AAA ", ">", " 7.0 )", " "] }), _jsxs(AllyChecker, Object.assign({ className: "lt-style" }, { children: [_jsxs("p", Object.assign({ style: { color: Level1Contrast.color } }, { children: ["The current contrast ratio is ", Level1Contrast.contrast] })), _jsx(FaInfoCircle, { id: "registerTip", "data-tooltip-html": ReactDOMServer.renderToString(_jsxs("div", { children: [_jsx("p", Object.assign({ className: "title-tooltip" }, { children: "WCAG Standards" })), _jsxs("p", { children: ["WCAG AA contrast ratio ", ">", " 4.5 "] }), _jsxs("p", { children: ["WCAG AAA contrast ratio ", ">", " 7 "] })] })) }), _jsx(Tooltip, { anchorId: "registerTip" })] })), _jsxs("fieldset", Object.assign({ className: "lt-style" }, { children: [_jsx("label", { children: "Text Format" }), _jsxs("select", Object.assign({ className: "lt-style", id: "level1-text-format", name: "level1-format", value: colors.level1.textFormat, onChange: (e) => setColors(Object.assign(Object.assign({}, colors), { level1: Object.assign(Object.assign({}, colors.level1), { textFormat: e.target.value }) })) }, { children: [_jsx("option", Object.assign({ value: "capitalize" }, { children: "capitalize" })), _jsx("option", Object.assign({ value: "uppercase" }, { children: "uppercase" }))] }))] }))] }), _jsxs(Column, { children: [_jsx(ColumnTitle, { children: "Level 2 bar" }), _jsxs("fieldset", Object.assign({ className: "lt-style" }, { children: [_jsx("label", { children: "Text Format" }), _jsxs("select", Object.assign({ className: "lt-style", id: "level2-text-format", name: "level2-format", value: colors.level2.textFormat, onChange: (e) => setColors(Object.assign(Object.assign({}, colors), { level2: Object.assign(Object.assign({}, colors.level2), { textFormat: e.target.value }) })) }, { children: [_jsx("option", Object.assign({ value: "capitalize" }, { children: "capitalize" })), _jsx("option", Object.assign({ value: "uppercase" }, { children: "uppercase" }))] }))] }))] })] })] }));
};
export default Style;
